(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-como-trabajamos"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__mmcr)return;
    root.__mmcr=true;
    var track=root.querySelector('.mm-ct__track'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    function step(){var c=track.children[0];return c?c.getBoundingClientRect().width+16:300;}
    function sync(){var s0=track.scrollLeft<=2,e0=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;prev.disabled=s0;next.disabled=e0;track.classList.toggle('has-left',!s0);track.classList.toggle('is-end',e0);}
    function font(){
      if(root.classList.contains('mm-ct--font'))return;
      var h=root.querySelector('.mm-ct__card h3');if(!h)return;
      var cs=getComputedStyle(h);
      root.querySelectorAll('.mm-ct__n').forEach(function(n){n.style.fontFamily=cs.fontFamily;});
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',function(){sync();font();});
    font();sync();
  }
  function all(){document.querySelectorAll('[data-mm-ct]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector?e.target.querySelector('[data-mm-ct]'):null;init(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-por-que-elegir"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__mmcr)return;
    root.__mmcr=true;
    var track=root.querySelector('.mm-pq__track'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    function step(){var c=track.children[0];return c?c.getBoundingClientRect().width+16:300;}
    function sync(){var s0=track.scrollLeft<=2,e0=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;prev.disabled=s0;next.disabled=e0;track.classList.toggle('has-left',!s0);track.classList.toggle('is-end',e0);}
    function font(){
      if(root.classList.contains('mm-pq--font'))return;
      var h=root.querySelector('.mm-pq__card h3');if(!h)return;
      var cs=getComputedStyle(h);
      root.querySelectorAll('.mm-pq__n').forEach(function(n){n.style.fontFamily=cs.fontFamily;});
    }
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',function(){sync();font();});
    font();sync();
  }
  function all(){document.querySelectorAll('[data-mm-pq]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector?e.target.querySelector('[data-mm-pq]'):null;init(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shimmy_b2b-formulario"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clean(v){return v.replace(/[^0-9kK]/g,'').toUpperCase();}
  function dv(b){var s=0,m=2;for(var i=b.length-1;i>=0;i--){s+=parseInt(b.charAt(i),10)*m;m=m===7?2:m+1;}var r=11-(s%11);return r===11?'0':(r===10?'K':String(r));}
  function fmt(v){var c=clean(v);if(c.length<2)return c;return c.slice(0,-1).replace(/\B(?=(\d\d\d)+(?!\d))/g,'.')+'-'+c.slice(-1);}
  function valid(v){var c=clean(v),b=c.slice(0,-1);return c.length>=8&&c.length<=9&&/^\d+$/.test(b)&&dv(b)===c.slice(-1);}
  document.addEventListener('input',function(e){
    var t=e.target;
    if(t&&t.matches&&t.matches('[data-mm-rut]')){t.value=fmt(t.value);t.setCustomValidity('');}
  });
  document.addEventListener('submit',function(e){
    var f=e.target,r=f&&f.querySelector?f.querySelector('[data-mm-rut]'):null;
    if(r&&!valid(r.value)){r.setCustomValidity('Ingresa un RUT válido, por ejemplo 12.345.678-5');r.reportValidity();e.preventDefault();}
  },true);
})();

  } catch(e) { console.error(e); }
})();
})();
